import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=6578c881&"
import script from "./EventsList.vue?vue&type=script&lang=ts&"
export * from "./EventsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports